import React from 'react';
import SubSpecialties from './sub_specialties';
import { type SubSpecialtiesProps } from './sub_specialties';
import Specialties from './specialties';
import { type SpecialtiesProps } from './specialties';
import type { TerritoriesProps } from './territories';
import Territories from './territories';

interface CompanyProfileProps {
  allBrokerSpecialties: SpecialtiesProps['allBrokerSpecialties'];
  allCompanyTerritories: TerritoriesProps['allCompanyTerritories'];
  allSubSpecialties: SubSpecialtiesProps['allSubSpecialties'];
  companySpecialties: SpecialtiesProps['companySpecialties'];
  companySubSpecialties: SubSpecialtiesProps['companySubSpecialties'];
  companyTerritories: TerritoriesProps['companyTerritories'];
  isCorporateUser: Boolean;
}

export default function CompanyProfile({
  allBrokerSpecialties,
  allCompanyTerritories,
  allSubSpecialties,
  companySpecialties,
  companySubSpecialties,
  companyTerritories,
  isCorporateUser
}: CompanyProfileProps) {
  return (
    <>
      <hr/>
      <Specialties
        allBrokerSpecialties={allBrokerSpecialties}
        companySpecialties={companySpecialties}
      />
      <SubSpecialties
        allSubSpecialties={allSubSpecialties}
        companySubSpecialties={companySubSpecialties}
      />
      <Territories
        allCompanyTerritories={allCompanyTerritories}
        companyTerritories={companyTerritories}
        isCorporateUser={isCorporateUser}
      />
    </>
  );
}
